export const initialScrapeTaskBatchStartViewPermission = {
    initialScrapeTaskBatchStartView: "initial-scrape-task-batch-starts.view",
    initialScrapeTaskBatchStartRun: "initial-scrape-task.batch-start",
};
